import { createStyles } from "@mantine/core"

// -- migrated from app/static/stylus/landing.styl -- //

export const useStyles = createStyles((theme) => ({
    landingPageWrapper: {
        height: "calc(100vh - var(--navbar-height))",

        // when you squish the page vertically, the components will snap to the TopNav instead of going past through it
        // TODO: change this to actually calculate navbar height + height of the landing page element
        [`@media (max-height: calc(45rem))`]: {
            alignItems: "initial",
            height: "initial",
            justifyContent: "initial",
        },
    },
    landingPage: {
        maxWidth: "52.5rem",
        minWidth: "0",
        padding: "0",

        // when you squish the page horizontally, the left + right padding will adjust based on the browser width to not look ugly
        [theme.fn.smallerThan("80rem")]: {
            paddingLeft: "4.5rem",
            paddingRight: "4.5rem",
        },
        [theme.fn.smallerThan("75rem")]: {
            paddingLeft: "3rem",
            paddingRight: "3rem",
        },
        [theme.fn.smallerThan("70rem")]: {
            paddingLeft: "1.5rem",
            paddingRight: "1.5rem",
        },
    },
    quorumBanner: {
        fill: theme.colors.brand[2],
        height: "4rem",
        margin: "auto",
        width: "14.375rem",
    },
    searchbarWrapper: {
        "& input": {
            border: `1px solid ${theme.colors.gray[3]}`,
            borderRadius: ".5rem",
            boxShadow: "0px 2px 4px -2px rgba(0, 0, 0, 0.12)",
            fontSize: "1rem",
            height: "3.5rem",
        },
    },
    searchbarInfo: {
        padding: ".5rem",

        "&:hover": {
            cursor: "pointer",
            backgroundColor: theme.colors.violet[1],
        },
    },
    favoritesAndHistoryWrapper: {
        height: "19rem",
    },
}))
